import { Modal } from "react-bootstrap";
import "./BaseModal.scss";
import { ReactNode } from "react";

interface BaseModalPropsI {
	show: boolean;
	onHide: () => void;
	title: string;
	children?: ReactNode;
}

function BaseModal(props: BaseModalPropsI) {
	const { show, onHide, title, children } = props;
	return (
		<Modal
			className="base-modal"
			show={show}
			onHide={onHide}
			aria-labelledby="contained-modal-title-vcenter"
			centered
		>
			<Modal.Header closeButton>
				<Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
			</Modal.Header>
			<Modal.Body>{children}</Modal.Body>
		</Modal>
	);
}

export default BaseModal;
